import { render, staticRenderFns } from "./roket.vue?vue&type=template&id=3e7d43bb&scoped=true&"
import script from "./roket.vue?vue&type=script&lang=js&"
export * from "./roket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7d43bb",
  null
  
)

export default component.exports